module.exports = __webpack_public_path__ + "media/insights/briefcase_icon-206fa71e.png";